export default {
    getEHRTableAdditionalConfig: state => state.ehrTableAdditionalConfig,
    getEHRActions: state => state.ehrActions,
    getEHRRowActions: state => state.ehrRowActions,
    getSpecRecSelectRowActions: state => state.specRecSelectRowActions,
    getEHRFormActions: state => state.ehrFormActions,
    getEHRTableSearchFields: state => state.ehrTableSearchFields,
    getEHRTableHeaderFields: state => state.ehrTableHeaderFields,
    getEHRFormConfig: state => state.ehrFormConfig,
    getEHRCovidRATFormConfig: state => state.ehrCovidRATFormConfig,
    getEHRSpecialistAdviceDrugFormConfig: state => state.ehrSpecialistAdviceDrugFormConfig,
    getSpecialistAdviceDrugFormConfig: state => state.specialistAdviceDrugFormConfig,

    isEHRGridShow: state => state.ehrGridIsShow,
    isEHRFormShow: state => state.ehrFormIsShow,
    isEHRCovidRATFormShow: state => state.ehrCovidAntigenTestFormIsShow,

    isEHRLabGridShow: state => state.ehrLabGridIsShow,
    isEHRLabFormShow: state => state.ehrLabFormIsShow,

    getLabDocumentsRowActions: state =>  state.labDocumentsRowActions,
    getLabDocumentsTableHeaderFields: state => state.labDocumentsTableHeaderFields,

    getEvidenceDocumentsRowActions: state =>  state.evidenceDocumentsRowActions,
    getEvidenceDocumentsTableHeaderFields: state => state.evidenceDocumentsTableHeaderFields,
    getEvidenceDocumentsTableConfig: state => state.evidenceDocumentsTableConfig
}
